module.exports = __webpack_public_path__ + "img/4064003140.663b1f75.jpg";